<pay-icon
    [name]="icon"
    class="x-btn__icon"
    [class.is-disabled]="disabled"
    (click)="manageIconClick($event)"
    *ngIf="icon && icon.length"
></pay-icon>
<ng-content></ng-content>